export default __webpack_public_path__ + "static/BioRhyme-Regular-hint-all-ac5987a37e598a47920fd71f49587ded.woff2";